export default __webpack_public_path__ + "static/6-37645302d48911ea259487e7c1347fc0.png";